import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import Login from './Views/Login.jsx';
import NotFound from './Views/NotFound.jsx';
import MainChat from './Views/MainWindow.jsx';
import Register from './Views/Register.jsx';

import './App.css';

function App() {
  let backgroundImage = useSelector(store=>store.ui.backgroundImage) || 1
  
  return (
    <Container fluid className='p-0 m-0'>
        <img src={require(`./images/back${backgroundImage}.jpg`).default} className='vh-100 w-100 position-absolute' style={{zIndex: -1}} alt='background'/>
        <Router 
          // basename={'/chat'}
        >
          <Switch>
              <Route exact path='/' component={Login}/>
              <Route exact path='/login' component={Login}/>
              <Route exact path='/register' component={Register}/>
              <Route path='/main' component={MainChat}/>
              <Route component={NotFound}/>
          </Switch>
        </Router>
    </Container>
  );
}

export default App;